export const notificationCategories = {
  tasks: 'Tareas y seguimiento', followups: 'Seguimientos', workflow: 'Actividades', projects: 'Proyectos', clients: 'Clientes',
  documents: 'Documentos', billing_documents: 'QT / PO / Invoice', finance: 'Finanzas', expense_requests: 'Comprobantes de gastos',
  email: 'Centro de correo', nda: 'Acuerdos y firmas', ndas: 'Acuerdos y firmas', chat: 'Chat', calendar: 'Calendario',
  quality: 'Calidad', security: 'Seguridad', system: 'Sistema', users: 'Usuarios', partner_quotes: 'Cotizaciones partner', commissions: 'Comisiones'
};
export const notificationCategoryLabel = (category) => Object.prototype.hasOwnProperty.call(notificationCategories, category) ? notificationCategories[category] : category || 'Sistema';
export const isNotificationRead = (notification) => [true, 1, '1'].includes(notification.read);
export const notificationDateGroup = (value, now = new Date()) => {
  if (!value) return 'Sin fecha';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return 'Sin fecha';
  const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
  if (parsed.toDateString() === now.toDateString()) return 'Hoy';
  if (parsed.toDateString() === yesterday.toDateString()) return 'Ayer';
  return 'Otras fechas';
};
export const notificationTimestamp = (value) => {
  if (!value || Number.isNaN(new Date(value).getTime())) return 'Sin fecha';
  return new Date(value).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
};
